import svgBack from "../../assets/SVGs/back.svg";
import classes from "./AppRoute.module.css";
import routeCardClasses from "../../components/homeComponents/RouteCard.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import ReactPlayer from "react-player";
import loadingGif from "../../assets/gifs/loading-spinner.gif";
import toast from "react-hot-toast";
import AuthProblem from "./authProblem";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function AppRoute() {
  const [TreeList, setTreeList] = useState([]);
  const [authProblem, setAuthProblem] = useState(false);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};
  const path = data.pathObj || {};
  const [loading, setLoading] = useState(false);
  const lastNavigation = useRef(Date.now());

  useEffect(() => {
    if (data.parent) {
      fetchData(data.parent);
    }
  }, [data]);

  const fetchData = async (subject) => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/bucket/list/Packages/${subject}`,
        requestOptions
      );
      const result = await response.json();
      setLoading(false);
      const fetchedTreeList = result.contents || [];
      setTreeList(fetchedTreeList);
      handleFileNavigation(fetchedTreeList);
      if (result?.error?.code === 1047) {
        toast.error(
          result.error.description || "خطایی رخ داد. لطفا مجددا تلاش کنید."
        );
        setAuthProblem(true);
      }
    } catch (error) {
      setLoading(false);
      setTreeList([]);
    }
  };

  const handleFileNavigation = (treeList) => {
    if (treeList.length === 0) return;

    const imageFile = treeList.find(
      (item) => item.name.endsWith(".jpg") || item.name.endsWith(".png")
    );
    const xlsxFile = treeList.find((item) => item.name.endsWith(".xlsx"));
    const pdfFile = treeList.find((item) => item.name.endsWith(".pdf"));
    const videoFile = treeList.find((item) => item.name.endsWith(".mp4"));
    const rarFile = treeList.find((item) => item.name.endsWith(".rar"));

    if (Date.now() - lastNavigation.current < 300) return;

    if (imageFile && xlsxFile) {
      lastNavigation.current = Date.now();
      navigate("/dataView", {
        state: {
          files: [
            { name: imageFile.name, download_url: imageFile.download_url },
            { name: xlsxFile.name, download_url: xlsxFile.download_url },
          ],
        },
      });
    } else if (imageFile) {
      lastNavigation.current = Date.now();
      navigate("/onlyPic", {
        state: { Address: imageFile.download_url, Parent: data.parent },
      });
    } else if (xlsxFile) {
      lastNavigation.current = Date.now();
      navigate("/dataView", {
        state: {
          name: xlsxFile.name,
          download_url: xlsxFile.download_url,
        },
      });
    } else if (pdfFile) {
      lastNavigation.current = Date.now();
      navigate("/PDFLayout", {
        state: {
          Address: pdfFile.download_url,
        },
      });
    } else if (videoFile) {
      lastNavigation.current = Date.now();
      navigate("/VideoPlayer", {
        state: {
          Address: videoFile.download_url,
        },
      });
    } else if (rarFile) {
      lastNavigation.current = Date.now();
      downloadRar(rarFile.download_url);
    }
  };

  const newRoute = (itemName) => {
    const item = TreeList.find((list) => list.name === itemName);
    if (!item) return;

    const newPath = { ...path, [itemName]: item };
    const newParent = `${data.parent}/${itemName}`;

    sessionStorage.setItem("temp1Data", JSON.stringify(newPath));
    sessionStorage.setItem("temp2Data", newParent);

    navigate("/AppRoute", {
      state: { pathObj: newPath, parent: newParent, TreeList },
    });
  };

  const downloadRar = async (url) => {
    try {
      navigate(-1);
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const blob = await response.blob();
      const urlBlob = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = urlBlob;
      a.download = url.split("/").pop();
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(urlBlob);
      toast.success("دانلود فایل با موفقیت انجام شد");
    } catch (error) {
      toast.error("خطا در دانلود فایل لطفا مجدد امتحان کنید");
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className={classes.main}>
      <div className={classes.header}>
        <div className={classes.return} onClick={handleBackClick}>
          <img src={svgBack} className={classes.svg} alt="Back" />
        </div>
        <div className={classes.route}>
          {data.parent ? data.parent.replaceAll("/", " / ") : ""}
        </div>
      </div>
      {loading ? (
        <div className={classes.loader}></div>
      ) : TreeList.length > 0 ? (
        <div className={classes.body}>
          {TreeList.map((item, index) => (
            <RouteCard
              key={index}
              text={item.name}
              image={item.img_url}
              customClickEvent={() => newRoute(item.name)}
            />
          ))}
        </div>
      ) : authProblem ? (
        <AuthProblem />
      ) : (
        <div className={classes.loading}>
          <p>داده ای در دسترس لطفا با پشتیبانی تماس بگیرید</p>
        </div>
      )}
    </div>
  );
}

function RouteCard(props) {
  const token = localStorage.getItem("token");
  const imageSrc = props.image;

  return (
    <div className={routeCardClasses.main} onClick={props.customClickEvent}>
      <img className={routeCardClasses.image} src={imageSrc} alt={props.text} />
      <div className={routeCardClasses.text}>
        <p>{props.text}</p>
      </div>
    </div>
  );
}

export default AppRoute;
